import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

function PaginationDot({ active, index, onClick }) {
  const classes = useStyles(active);

  const handleOnClick = () => {
    onClick?.call(this, index);
  };

  return (
    <button
      type="button"
      className={classes.container}
      onClick={handleOnClick}
      aria-label="dot"
    >
      <div className={classes.dot} />
    </button>
  );
}

const useStyles = createUseStyles({
  container: {
    height: 16,
    width: 16,
    cursor: 'pointer',
    border: 0,
    background: 'none',
    padding: 0,
  },
  dot: {
    backgroundColor: (active) => (active ? '#fff' : '#fff'),
    opacity: (active) => (active ? 1 : 0.4),
    height: 8,
    width: 8,
    // boxSha
    boxShadow: '0px 0px 4px #111',
    borderRadius: 6,
    margin: 3,
    border: '1px solid white',
  },
});

PaginationDot.propTypes = {
  active: PropTypes.bool.isRequired,
  // onClick: PropTypes.func.isRequired,
};

export { PaginationDot };
